import { flow, getEnv, types } from "mobx-state-tree";
import { CodeModel } from "./CodeModel";
import Notification from "../../utils/Notification";

export const CodeModelList = types.model({
  items: types.optional(types.array(CodeModel), []),
  isLoading: types.optional(types.boolean, false), //types.enumeration('State', ['pending', 'done', 'error']),
  page: types.optional(types.integer, 1),
  perPage: types.optional(types.integer, 10),
  totalRows: types.optional(types.integer, 0),
  sortOrder: types.optional(types.string, "desc"),
  sortField:  types.optional(types.string, "updatedAt"),
  esWindowLimit: types.optional(types.number, 10000),
  searchAfterValues: types.optional(types.array(types.frozen()), []),
  actualTotalRows: types.optional(types.integer, 0),
}).volatile(self => ({
  searchParams: {},
  filters: {}
})).actions((self) => ({
  getItems() {
    return self.items
  },
  setSortOrder(sortDirection){
    self.sortOrder = sortDirection
  },
  setSortField(sortField){
    self.sortField = sortField
  },
  fetchAll: flow(function* fetchAll(sortParams = {}) {
    // self.items = []
    self.isLoading = true
    try {
      const queryParams = {
        page: self.page,
        perPage: self.perPage,
        ...sortParams,
        ...self.searchParams
      }

      const manager = getEnv(self).codeManager
      console.log("queryParams in fetchAll",queryParams)
      const response = yield manager.fetchAllCodes(queryParams);

      if(response != null) {
        console.log("response.results", response.results);
        //CodeModel.create({uuid: one.uuid, status: one.status}) //TODO: convert
        response.results.map( (code) => {
          if(code.tags) {
            code.tags.map((tag) => {
              tag.namespace = "codelist"
              tag.uuid = "codelist." + tag.uuid;
            })
          } else {
            code.tags = [];
          }
        })
        self.items = response.results;
        self.totalRows = response._meta.itemCount;
        self.isLoading = false;
      } else {
        self.isLoading = false;
      }
    } catch (error) {
      console.error('Failed to fetch code', error)
    }
  }),
  fetchAllFilters: flow(function* fetchAllFilters(sortParams = {}) {
    self.isLoading = true
    try {
      const queryParams = {
        ...self.searchParams
      }

      const manager = getEnv(self).codeManager;
      console.log("codeManager", manager)
      const response = yield manager.fetchAllFilters(queryParams);
      if(response != null) {
        self.filters = response
        self.isLoading = false;
        //CodeModel.create({uuid: one.uuid, status: one.status}) //TODO: convert
      } else {
        self.isLoading = false;
      }
    }
    catch (error) {
      console.error('Failed to fetch code', error)
    }
  }),
  searchResults: flow(function* searchResults(sortParams = {}, isElasticSearchEnabled = false) {
    self.isLoading = true;
    try {
      const queryParams = {
        perPage: self.perPage,
        ...sortParams,
        ...self.searchParams
      }

      if (isElasticSearchEnabled && self.isCursorMode()) {
        // Tell backend to use search_after mode
        // Include searchAfter values if we have them from previous page
        if (self.searchAfterValues.length > 0) {
          queryParams.searchAfter = JSON.stringify(self.searchAfterValues)
          queryParams.useSearchAfter = true
        }
      } else {
        // Normal pagination mode
        queryParams.page = self.page
      }

      const manager = getEnv(self).codeManager
      console.log("queryParams in fetchAll",queryParams)
      const response = yield manager.search(queryParams);

      if(response != null) {
        console.log("response.results", response.results);
        //CodeModel.create({uuid: one.uuid, status: one.status}) //TODO: convert
        response?.results.forEach( (code) => {
          if(code.tags) {
            code.tags.forEach((tag) => {
              tag.namespace = "codelist"
              tag.uuid = "codelist." + tag.uuid;
            })
          } else {
            code.tags = [];
          }
        })
        self.items = response.results;
        self.actualTotalRows = response._meta.itemCount;
        self.totalRows = Math.min(response._meta.itemCount, self.esWindowLimit);
        // Store searchAfter values from lastSort
        if (response._cursor && response._cursor.nextCursor) {
          self.searchAfterValues = response._cursor.nextCursor
          console.log("Stored search_after values from lastSort:", self.searchAfterValues);
        }
        self.isLoading = false;
      } else {
        self.isLoading = false;
      }
    } catch (error) {
      console.error('Failed to fetch code', error)
    }
  }),
  addItems(item){
    self.items.push(item)
  },
  updatePage: function (page) {
    self.page = page
  },
  updatePerPage: function (perPage) {
    self.perPage = perPage
  },
  addSearchParams(param){
    self.searchParams = {...self.searchParams, ...param}
    self.resetPaginationState();
  },
  removeSearchParams(names,regex = ''){
    if(names){
      names.map((name) => delete self.searchParams[name])
    }
    if(regex){
      const keysToDelete = Object.keys(self.searchParams).filter(key => regex.test(key));
      keysToDelete.forEach(key => delete self.searchParams[key]);
    }
    self.resetPaginationState();
  },
  removeItem(uuid){
    self.items = self.items.filter(item => item.uuid !== uuid)
  },
  resetPaginationState() {
    self.page = 1;
    self.searchAfterValues = [];
  },
  afterCreate() {
    console.log("Init Search Params")
    self.searchParams = {}
  },
  removeList(){
    self.items = []
  },
  publish: flow(function* (obj) {
    const code = self.items.find(item => item.uuid === obj.uuid)
    const manager = getEnv(self).codeManager
    const resp = yield manager.publish(obj, code);

    if (resp?.error?.status === 403) return

    obj.formHasErrors && new Notification()
      .setType("error")
      .setMessage(`${code?.name} Code failed publishing`)
      .send();

    !obj.formHasErrors && new Notification()
      .setType("success")
      .setMessage(`${code?.name} Code published`)
      .send();

    !obj.formHasErrors && obj.notifyThirdCallBack(resp.uuid);
    !obj.formHasErrors && obj.notifyCallBack()


  }),
  complete: flow(function* (obj) {
    const code = self.items.find(item => item.uuid === obj.uuid)
    const manager = getEnv(self).codeManager
    const resp = yield manager.complete(obj, code);

    if (resp?.error?.status === 403) return

    obj.formHasErrors && new Notification()
      .setType("error")
      .setMessage(`${code?.name} Code failed Completing`)
      .send();

    !obj.formHasErrors && new Notification()
      .setType("success")
      .setMessage(`${code?.name} Code Completed`)
      .send();

    !obj.formHasErrors && obj.notifyThirdCallBack(resp.uuid);
    !obj.formHasErrors && obj.notifyCallBack()


  }),
  audit: flow(function* (obj) {
    const manager = getEnv(self).codeManager
    const resp = yield manager.saveAuditNotesToCode(obj);

    obj.formHasErrors && new Notification()
      .setType("error")
      .setMessage(`Audit not saved to the code`)
      .send();

    !obj.formHasErrors && new Notification()
      .setType("success")
      .setMessage(`Audit saved to the code`)
      .send();
    //
    !obj.formHasErrors && obj.notifyModalCallBack()
  }),
})).views((self) => ({
  getSearchParams() {
    return self.searchParams;
  },
  isCursorMode() {
    const startIndex = (self.page - 1) * self.perPage;
    return startIndex + self.perPage > self.esWindowLimit;
  }
}));
